import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      advantageOfPotentialFuture: boolean(Joi).label(
        labeled(label, 'To take advantage of potential future decreases in the interest rate')
      ),
      flexibilityWithRespectToRepayment: boolean(Joi).label(
        labeled(label, 'ty with respect to repayment, redraw and/or early repayment of loan')
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue('advantageOfPotentialFuture', 'flexibilityWithRespectToRepayment', 'other')
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
